var _defs, _path, _path2, _ellipse, _rect, _rect2, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoflap01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 423 520",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-67,.cls-66{fill:#fff;stroke:#000;stroke-miterlimit:10;}.cls-67{stroke-width:3px;}.cls-66{stroke-dasharray:3.01;}.cls-65{fill:#010101;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M355.25,204.48v62.27c0,23.77-20.67,43.05-46.16,43.05H117.41c-25.49,0-46.16-19.28-46.16-43.05V204.48Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M352.12,207.15v60.2c0,21.37-19.3,38.75-43,38.75H117.41c-23.71,0-43-17.38-43-38.75v-60.2Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 213.58,
    cy: 277.25,
    rx: 16.66,
    ry: 16.15
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 211.86,
    y: 255.32,
    width: 3.44,
    height: 44.93
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: 207.76,
    y: 27.54,
    width: 11.66,
    height: 467.15,
    transform: "translate(-123.75 263.23) rotate(-51.08)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: -20.01,
    y: 255.25,
    width: 467.15,
    height: 11.66,
    transform: "translate(-116.62 192.15) rotate(-38.92)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoflap01);
export default __webpack_public_path__ + "static/media/NO FLAP-01.3c05623a5ab284ef0157fc066a53e2df.svg";
export { ForwardRef as ReactComponent };